// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/GoogleSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/GoogleSans-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/GoogleSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/GoogleSans-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/GoogleSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/GoogleSans-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-UltraLightItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-UltraLightItalic.woff') format('woff');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-UltraLight.woff2') format('woff2'),
        url('../fonts/Gilroy-UltraLight.woff') format('woff');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-SemiBoldItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-SemiBoldItalic.woff') format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-ThinItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-ThinItalic.woff') format('woff');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-SemiBold.woff2') format('woff2'),
        url('../fonts/Gilroy-SemiBold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Thin.woff2') format('woff2'),
        url('../fonts/Gilroy-Thin.woff') format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Medium.woff2') format('woff2'),
        url('../fonts/Gilroy-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-LightItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-LightItalic.woff') format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Regular.woff2') format('woff2'),
        url('../fonts/Gilroy-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-MediumItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-MediumItalic.woff') format('woff');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: '../fonts/Gilroy-RegularItalic';
    src: url('../fonts/Gilroy-RegularItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-RegularItalic.woff') format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Heavy.woff2') format('woff2'),
        url('../fonts/Gilroy-Heavy.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-HeavyItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-HeavyItalic.woff') format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Light.woff2') format('woff2'),
        url('../fonts/Gilroy-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-ExtraBoldItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-ExtraBoldItalic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-BoldItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-BoldItalic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Bold.woff2') format('woff2'),
        url('../fonts/Gilroy-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-ExtraBold.woff2') format('woff2'),
        url('../fonts/Gilroy-ExtraBold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-BlackItalic.woff2') format('woff2'),
        url('../fonts/Gilroy-BlackItalic.woff') format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}
@font-face {
    font-family: 'Gilroy';
    src: url('../fonts/Gilroy-Black.woff2') format('woff2'),
        url('../fonts/Gilroy-Black.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}
 */


@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Google Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/fonts.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiLE;;;AAGF;IACI,0BAA0B;IAC1B,+DAA8D;IAC9D,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,+DAA6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,+DAA2D;IAC3D,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,+DAAiE;IACjE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,+DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,+DAAmE;IACnE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["/* @font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-UltraLightItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-UltraLightItalic.woff') format('woff');\n    font-weight: 200;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-UltraLight.woff2') format('woff2'),\n        url('../fonts/Gilroy-UltraLight.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-SemiBoldItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-SemiBoldItalic.woff') format('woff');\n    font-weight: 600;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-ThinItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-ThinItalic.woff') format('woff');\n    font-weight: 100;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-SemiBold.woff2') format('woff2'),\n        url('../fonts/Gilroy-SemiBold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Thin.woff2') format('woff2'),\n        url('../fonts/Gilroy-Thin.woff') format('woff');\n    font-weight: 100;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Medium.woff2') format('woff2'),\n        url('../fonts/Gilroy-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-LightItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-LightItalic.woff') format('woff');\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Regular.woff2') format('woff2'),\n        url('../fonts/Gilroy-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-MediumItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-MediumItalic.woff') format('woff');\n    font-weight: 500;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: '../fonts/Gilroy-RegularItalic';\n    src: url('../fonts/Gilroy-RegularItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-RegularItalic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Heavy.woff2') format('woff2'),\n        url('../fonts/Gilroy-Heavy.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-HeavyItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-HeavyItalic.woff') format('woff');\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Light.woff2') format('woff2'),\n        url('../fonts/Gilroy-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-ExtraBoldItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-ExtraBoldItalic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-BoldItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-BoldItalic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Bold.woff2') format('woff2'),\n        url('../fonts/Gilroy-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-ExtraBold.woff2') format('woff2'),\n        url('../fonts/Gilroy-ExtraBold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-BlackItalic.woff2') format('woff2'),\n        url('../fonts/Gilroy-BlackItalic.woff') format('woff');\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap;\n}\n@font-face {\n    font-family: 'Gilroy';\n    src: url('../fonts/Gilroy-Black.woff2') format('woff2'),\n        url('../fonts/Gilroy-Black.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n */\n\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-Italic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-BoldItalic.ttf') format('truetype');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Google Sans';\n    src: url('../fonts/GoogleSans-MediumItalic.ttf') format('truetype');\n    font-weight: 500;\n    font-style: italic;\n    font-display: swap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
